<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Careers</h2>

        <small class="text-muted">Manage all your careers here. </small>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Create
          Content
        </span>
      </base-button>
    </div>
    <CareerTable />
  </b-card>
</template>

<script>
import CareerTable from "./components/CareerTable.vue";

export default {
  components: {
    CareerTable,
  },

  methods: {
    handleAdd() {
      this.$router.push({ name: "create-career" });
    },
  },
};
</script>
